import React from "react";
import styled from "styled-components";
import PretendardText from "../../../../component/atoms/text/pretendardText";

const SelectGroupBox = ({
  style,
  isOpen,
  wrapperHandler,
  selectedValues, // 배열로 변경
  placeholder,
  selectedValueSetterFunc,
  itemList,
}) => {
  const handleItemClick = (item) => {
    if (selectedValues.includes(item.title)) {
      // 이미 선택된 항목이면 배열에서 제거
      selectedValueSetterFunc(
        selectedValues.filter((selected) => selected !== item.title)
      );
    } else {
      // 선택되지 않은 항목이면 배열에 추가
      selectedValueSetterFunc([...selectedValues, item.title]);
    }
  };

  return (
    <SelectGroupBoxContainer style={{ ...style }}>
      <SelectGroupBoxText onClick={() => wrapperHandler(!isOpen)}>
        {selectedValues.length > 0
          ? selectedValues.join(", ") // 선택된 값들을 콤마로 구분
          : placeholder}
      </SelectGroupBoxText>
      {isOpen && (
        <SubMenuWrapper className="custom-scrollbar">
          {itemList.map((item, index) => (
            <SubMenuTextWrapper
              key={index}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: 210,
                height: "42px",
                padding: "10px",
                cursor: "pointer",
              }}
              onClick={() => {
                handleItemClick(item);
                wrapperHandler(!isOpen);
              }}
            >
              <PretendardText
                style={{
                  color: selectedValues.includes(item.title)
                    ? "#aaa"
                    : "var(--text3, rgba(181, 181, 181, 0.5))",
                  fontSize: "15px",
                  fontWeight: "500",
                  lineHeight: "21.5px",
                }}
              >
                {item.title}
              </PretendardText>
              {selectedValues.includes(item.title) ? (
                <img
                  style={{
                    width: "18px",
                    height: "18px",
                  }}
                  src="/assets/admin/icons/ico_select_checked.svg"
                  alt=""
                />
              ) : null}
            </SubMenuTextWrapper>
          ))}
        </SubMenuWrapper>
      )}
    </SelectGroupBoxContainer>
  );
};

export default SelectGroupBox;

const SelectGroupBoxContainer = styled.div.attrs((props) => {})`
  position: relative;
  width: 230px;
`;

const SelectGroupBoxText = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  letter-spacing: -0.3%;
  cursor: pointer;
  color: rgba(181, 181, 181, 0.5);
`;

const SubMenuWrapper = styled.div.attrs((props) => {})`
  width: 230px;
  min-height: 100px;
  max-height: 188px;
  border-radius: 3px;
  background: #313233;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 53px;
  right: 0;
  padding: 10px;
  overflow-y: scroll;
  overflow-x: hidden;
  z-index: 5;
`;

const SubMenuTextWrapper = styled.div.attrs((props) => {})`
  display: "flex";
  justify-content: "space-between";
  align-items: "center";
  width: "318px";
  height: "42px";
  padding: "10px";
  cursor: "pointer";
  border-radius: 3px;
`;
